// Brand colour theming. The palette lives in CSS custom properties declared
// in assets/css/tokens.scss; here we only override them for PolDo instances.

// #0ead69, with each shade derived from it by the same operation that maps
// the default blue to its own shades: darken(7.5%) for :hover,
// darken(10%) for :active and lighten(43.5%) for the pale tint. The
// btn-hover/link-hover/focus-border/pressed shades are Bootstrap's own,
// derived as in tokens.scss (darken 7.5%/12.5%/15%, lighten 25%/35%,
// mix with white 15% for the button focus ring).
// It is as dark as the blue, so --lisaweb-fg keeps its default (light text).
const POLDO_PALETTE = {
  "--lisaweb": "#0ead69",
  "--lisaweb-hover": "#0b8a54",
  "--lisaweb-active": "#0a7e4c",
  "--lisaweb-rgb": "14, 173, 105",
  "--lisaweb-light": "#a1f7d3",
  "--shadow-rgb": "161, 247, 211",
  "--primary": "#0ead69",
  "--lisaweb-btn-hover": "#0b8a54",
  "--lisaweb-link-hover": "#08663e",
  "--lisaweb-focus-border": "#4af0a9",
  "--lisaweb-pressed": "#79f4c0",
  "--lisaweb-btn-active-border": "#097245",
  "--lisaweb-btn-focus-rgb": "50, 185, 128",
  // Righe delle tabelle nella tinta del brand, come l'azzurro del tema base.
  "--color-row-odd": "#eef9f4",
  "--color-row-even": "#d7f3e6",
};

export const isPoldo = () => window.location.href.includes("poldo_");

export const applyBrandTheme = () => {
  if (!isPoldo()) return;
  Object.entries(POLDO_PALETTE).forEach(([prop, value]) =>
    document.documentElement.style.setProperty(prop, value),
  );
};
